import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const MFA_METHODS_QUERY = gql`
  query MfaMethodsQuery {
    mfaMethods {
      requireMfa
      passkeysAvailable
      methods {
        id
        type
        confirmed
        isRecoveryMethod
        phoneNumber
        name
        createdAt
        lastAuth
        aaguid
        userAgent
      }
    }
  }
`;

export function useMfaMethods({ skip = false } = {}) {
  const { data, loading, error, refetch } = useQuery(MFA_METHODS_QUERY, {
    noThrow: true,
    skip,
  });

  useError(error);

  return {
    methods: data?.mfaMethods?.methods || [],
    requireMfa: data?.mfaMethods?.requireMfa || false,
    passkeysAvailable: data?.mfaMethods?.passkeysAvailable || false,
    error,
    loading,
    refetch,
  };
}
